import { ThemeProvider } from '@material-ui/styles';
import React, { Component } from 'react'
import { IoIosArrowBack } from 'react-icons/io';
import { withRouter } from "react-router-dom";
import purchasedPack from '../../actions/purchasedPack'


class SelectedPlan extends Component {

    constructor(props){
        super(props);

        this.state = {
            user_plan: '',
            user_value: '',
        }

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount(){
        if(this.props.user){
            purchasedPack.getPurchasedPack().then(resolve => {
                console.log(resolve)
                this.setState({
                    user_plan: resolve.data.data.pack_data.name,
                    user_value: resolve.data.data.pack_data.value
                })
            })
        }
    }

    handleClick(){
        this.props.history.push("/dashboard");
    }

    render(){

        return(
            this.props.user == true ? (
                <div onClick={() => this.handleClick()} className="selected-plan user-plan">

                    <IoIosArrowBack />
                    <small>Seu plano atual</small>
                    <h2>
                        {this.state.user_plan}
                        {/* R$ {this.state.user_value} */}
                    </h2>
                </div>
            ) : (
                <div className="selected-plan">

                    <small>Plano escolhido</small>
                    <h2>
                        {localStorage.getItem("user_plan_name")} - 
                        R$ {localStorage.getItem("user_plan_price")}
                    </h2>
                </div>
            )
        )
    }
}

export default withRouter(SelectedPlan)